import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ExclusionRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const { api, columnApi, data } = this.props;
    this.props.onRequestEdit(data, api, columnApi);
  }


  render() {
    const { value } = this.props;
    if (value) {
      return (
        <a href="" onClick={this.handleClick}>
          {value}
        </a>
      );
    }
    return <div>{value}</div>;
  }
}

ExclusionRenderer.propTypes = {
  value: PropTypes.string,
  onRequestEdit: PropTypes.func,
};
ExclusionRenderer.defaultProps = {
  value: null,
  onRequestEdit: () => {},
};

export default ExclusionRenderer;
